import { render, staticRenderFns } from "./SearchCommon.vue?vue&type=template&id=4b604664&scoped=true"
import script from "./SearchCommon.vue?vue&type=script&lang=js"
export * from "./SearchCommon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b604664",
  null
  
)

export default component.exports